import React from 'react';
import PropTypes from 'prop-types';

export default function CloseIcon({ width, height, color }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M8.55716 0.442842C8.41798 0.30252 8.2524 0.191144 8.06997 0.115138C7.88753 0.0391321 7.69185 0 7.49421 0C7.29658 0 7.1009 0.0391321 6.91846 0.115138C6.73602 0.191144 6.57044 0.30252 6.43127 0.442842L4.5 2.38908L2.56873 0.442842C2.28682 0.160931 1.90447 0.00255568 1.50579 0.00255568C1.10711 0.00255568 0.724752 0.160931 0.442842 0.442842C0.160931 0.724752 0.00255568 1.10711 0.00255568 1.50579C0.00255568 1.90447 0.160931 2.28682 0.442842 2.56873L2.38908 4.5L0.442842 6.43127C0.30252 6.57044 0.191144 6.73602 0.115138 6.91846C0.0391321 7.1009 0 7.29658 0 7.49421C0 7.69185 0.0391321 7.88753 0.115138 8.06997C0.191144 8.2524 0.30252 8.41798 0.442842 8.55716C0.582017 8.69748 0.747598 8.80886 0.930035 8.88486C1.11247 8.96087 1.30815 9 1.50579 9C1.70342 9 1.8991 8.96087 2.08154 8.88486C2.26398 8.80886 2.42956 8.69748 2.56873 8.55716L4.5 6.61092L6.43127 8.55716C6.57044 8.69748 6.73602 8.80886 6.91846 8.88486C7.1009 8.96087 7.29658 9 7.49421 9C7.69185 9 7.88753 8.96087 8.06997 8.88486C8.2524 8.80886 8.41798 8.69748 8.55716 8.55716C8.69748 8.41798 8.80886 8.2524 8.88486 8.06997C8.96087 7.88753 9 7.69185 9 7.49421C9 7.29658 8.96087 7.1009 8.88486 6.91846C8.80886 6.73602 8.69748 6.57044 8.55716 6.43127L6.61092 4.5L8.55716 2.56873C8.69748 2.42956 8.80886 2.26398 8.88486 2.08154C8.96087 1.8991 9 1.70342 9 1.50579C9 1.30815 8.96087 1.11247 8.88486 0.930035C8.80886 0.747598 8.69748 0.582017 8.55716 0.442842Z" fill={color} />
    </svg>
  );
}

CloseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

CloseIcon.defaultProps = {
  color: '#FFFFFF',
  width: 9,
  height: 9,
};
